import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AboutComponent } from './components/about/about.component';
import { CarruselComponent } from './components/carrusel/carrusel.component';
import { FeaturedServicesComponent } from './components/featured-services/featured-services.component';
import { FooterComponent } from './components/footer/footer.component';
import { HomeComponent } from './components/home/home.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { RegistroOnlineComponent } from './components/registro-online/registro-online.component';
import { ServicesComponent } from './components/services/services.component';
import { TeamComponent } from './components/team/team.component';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { VerificarRegistroComponent } from './components/verificar-registro/verificar-registro.component';
import { SessionComponent } from './components/session/session.component';
import { NgbModule, NgbCalendar, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { PerfilComponent } from './components/perfil/perfil.component';
import { DateParserFormatter } from './classes/date-parser-formater';
import { SplashComponent } from './components/splash/splash.component';
import { ResetearClaveComponent } from './components/session/resetear-clave/resetear-clave.component';
import { ConfirmarClaveComponent } from './components/session/confirmar-clave/confirmar-clave.component';


@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    CarruselComponent,
    AboutComponent,
    FeaturedServicesComponent,
    ServicesComponent,
    TeamComponent,
    FooterComponent,
    RegistroOnlineComponent,
    HomeComponent,
    VerificarRegistroComponent,
    SessionComponent,
    PerfilComponent,
    SplashComponent,
    ResetearClaveComponent,
    ConfirmarClaveComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    NgbModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      closeButton: true
    }),
    FormsModule
  ],
  providers: [
    {provide: NgbDateParserFormatter, useClass: DateParserFormatter}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
